import * as React from "react";
import StoreContainer from "../stores/StoreContainer";
import {
  InlineChatInvite,
  Message,
  LineCreator,
  LineRating,
  MessageStatusType,
  LineType,
  ChatUIStage,
  EngagementConfiguration,
  InvitationType
} from "../types";
import ChatMessageList from "./ChatMessageList";
import ReactDOM = require("react-dom");
import IFramePortal from "./IFramePortal";
import DefaultHead from "./DefaultHead";
import ChatInviteHeader from "./ChatInviteHeader";
import ChatInviteForm from "./ChatInviteForm";
import MessengerFlexContainer from "./MessengerFlexContainer";
import ChatMessageBox from "./ChatMessageBox";
import * as Icons from "./Icons";
import { useMemo, useState } from "react";

interface InlineChatInviteProps {
  container: HTMLElement;
  invite: InlineChatInvite;
  config: EngagementConfiguration;
}

function InlineChatInviteView({
  container,
  invite,
  config
}: InlineChatInviteProps) {
  const [text, setText] = useState("");

  function onClickReject() {
    if (!invite.fromBubble) {
      StoreContainer.InviteStore.reject();
    }
      StoreContainer.InviteStore.closeInlineInvite();
  }

  async function onSendAccept() {
    //Bubble invites are accepted when the invite is clicked on, not when the message is sent.
    if (!invite.fromBubble) {
      StoreContainer.InviteStore.accept();
      StoreContainer.InviteStore.closeInlineInvite();
    }
    StoreContainer.InviteStore.setInviteAcceptMessage(text);
    StoreContainer.FrameStore.expandOrPopout();
  }

  function renderInvite() {
    let messages: Message[] = invite.messages.map((message, i) => {
      return {
        id: i + 1,
        type: LineType.PreEngagement,
        timestamp: new Date(),
        text: message,
        lineCreator: LineCreator.Agent,
        rating: LineRating.Unset,
        headshotUrl: invite.authorHeadshotUrl,
        author: invite.authorName,
        status: MessageStatusType.Received
      };
    });

    return (
      <MessengerFlexContainer>
        <ChatInviteHeader
          agentName={invite.authorName}
          agentHeadshotUrl={invite.authorHeadshotUrl}
          onClose={onClickReject}
        />
        <ChatMessageList
          chatStage={ChatUIStage.Loading}
          secureForm={null}
          dataField={null}
          onSubmitDataField={() => { }}
          quickReplies={[]}
          messages={messages}
          agentsTyping={[]}
          showUploadProgress={false}
          uploadPercentage={0}
          onClickExit={() => { }}
          onSetLineRating={() => { }}
          onResendMessage={() => { }}
          onClickQuickReply={() => { }}
          onClickActionCard={() => { }}
        />
        <div className="velaro-message-form" tabIndex={0}>
          <ChatMessageBox
            value={text}
            onChange={(text: string) => setText(text)}
            onEnter={onSendAccept}
            placeholder={invite.placeholderText}
          />
          <div className="velaro-message-form-actions">
            <button
              className="velaro-message-send-button velaro-bg-primary"
              onClick={onSendAccept}
              aria-label="Begin chatting"
            >
              <Icons.SendIcon color={config.PrimaryTextColor} />
            </button>
          </div>
        </div>
      </MessengerFlexContainer>
    );
  }

  return renderInvite();
}

export default InlineChatInviteView;
